<template>
  <div>
    <v-textarea
      v-model="$v.egrnConfirmDetails.dealType.$model"
      :errorMessages="getValidationErrorText($v.egrnConfirmDetails.dealType)"
      outlined
      label="Вид сделки в отношении объекта недвижимости, для совершения которой необходимы сведения"
    />

    <Footer
      @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
      @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
      :loading-next="loadingNext"
    />
  </div>
</template>

<script>
import { checkInvalid, leaveStep } from '@/utils/services';
import { StepDirection, StepName } from '@/types/services';
import { required } from 'vuelidate/lib/validators';
import { getValidationErrorText } from '@/utils/validate';
import Footer from '@/components/services/elements/Footer';
import deepmerge from 'deepmerge';
import { ServicesModule } from '@/store/modules/services';
import { EgrnConfirmStep } from '@/constants';

export default {
  name: 'DealForm',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data: () => ({
    getValidationErrorText,
    StepDirection,
    StepName,
    leaveStep,
    invalidFields: [],
    egrnConfirmDetails: {
      dealType: '',
    },
  }),
  validations() {
    return {
      egrnConfirmDetails: {
        dealType: {
          required,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      this.egrnConfirmDetails = deepmerge(
        this.egrnConfirmDetails,
        ServicesModule.statement.egrnConfirmDetails
      );
    },

    touchFields() {
      this.invalidFields = [];
      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    assemblyModel() {
      return this.egrnConfirmDetails.dealType;
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: EgrnConfirmStep.PROOF,
      });
    },
  },
};
</script>
